import { useState } from "react";
import { downloadAdminCsv } from "../api/tcg";

function AdminExport({ token }: { token: string }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    async function handle(path: string, filename: string) {
        setBusy(true);
        setError(null);
        try {
            await downloadAdminCsv(token, path, filename);
        } catch (err) {
            setError(err instanceof Error ? err.message : "Download fehlgeschlagen.");
        } finally {
            setBusy(false);
        }
    }

    return (
        <section className="admin-card">
            <h2 className="admin-card-title">Export</h2>
            <p className="admin-note" style={{ marginBottom: "16px" }}>
                Lade die aktuellen Stände als CSV-Datei herunter (öffnet sich direkt in Excel).
            </p>

            {error && <p className="admin-error">{error}</p>}

            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                <button className="admin-btn-primary" disabled={busy}
                    onClick={() => handle("/api/admin/export/nominations", "nominierungen.csv")}>
                    Nominierungen (CSV)
                </button>
                <button className="admin-btn-primary" disabled={busy}
                    onClick={() => handle("/api/admin/export/results", "voting-ergebnisse.csv")}>
                    Voting (CSV)
                </button>
            </div>
        </section>
    );
}

export default AdminExport;
